export default __webpack_public_path__ + "static/media/sch3_w1024.f8e8db57.jpg";